export const GetQRResourcesDE: GetQRResourcesInterface = {
  title: "Name des Anwendungspunkts",
  subtitle: "Geplante Aufgaben",
  buttons: {
    popuni: "Ausfüllen",
    pregled: "Vorschau",
    primjedbe: "Kommentare",
  },
  errors: {
    noinput:
      "Erforderliche Felder sind nicht eingegeben. Bitte kontaktieren Sie den Administrator.",
    errorQuery:
      "Beim Sammeln von Daten ist ein Fehler aufgetreten. Bitte kontaktieren Sie den Administrator.",
    recordPointNotFound: {
      title: "Aufzeichnungspunkt nicht gefunden",
      message:
        "Der angeforderte Aufzeichnungspunkt wurde im System nicht gefunden.",
      suggestion: "Bitte kontaktieren Sie den Administrator für Hilfe.",
      icon: "mdi mdi-alert-circle-outline",
    },
    privateAccess: {
      title: "Privater Aufzeichnungspunkt",
      message:
        "Dieser Aufzeichnungspunkt ist privat und nur autorisierten Benutzern zugänglich. Eine Anmeldung ist erforderlich, um auf diese Daten zuzugreifen.",
      suggestion:
        "Bitte kontaktieren Sie den Administrator für den Zugang oder melden Sie sich im System an.",
      icon: "mdi mdi-lock-outline",
      mobileMessage:
        "Dieser Aufzeichnungspunkt ist privat. Anmeldung für Zugang erforderlich.",
      mobileSuggestion: "Administrator für Zugang kontaktieren.",
    },
  },
  noItems: {
    title: "Keine Evidenz verfügbar",
    message:
      "Für den ausgewählten Zeitraum und die Kriterien ist keine Evidenz verfügbar.",
    suggestion:
      "Bitte überprüfen Sie den Datumsbereich oder kontaktieren Sie den Administrator.",
  },
  noActiveRecords: {
    title: "Keine aktive Evidenz",
    message:
      "Für den gescannten Anwendungspunkt gibt es keine aktiven Evidenzdatensätze, die ausgefüllt werden müssen.",
    suggestion:
      "Die Evidenz wurde bereits für den ausgewählten Zeitraum ausgefüllt. Bitte überprüfen Sie den Datumsbereich oder kontaktieren Sie den Administrator.",
  },
  noRecordPoints: {
    message:
      "Derzeit gibt es keine Aufzeichnungspunkte für den ausgewählten Zeitraum. Bitte wählen Sie einen anderen Datumsbereich.",
  },
  inputFields: {
    endDate: {
      label: "Enddatum",
    },
    startDate: {
      label: "Startdatum",
    },
  },
  poljaEvidencije: {
    CIPP_V1: "Reinigung und Waschen von Räumen",
    CIPO_V1: "Reinigung und Waschen von Geräten",
    Dezinfekcija_V1: "Desinfektion",
    Dezinsekcija_V1: "Schädlingsbekämpfung",
    Deratizacija_V1: "Nagetierkontrolle",
    Dezinsekcija_Kontrola_V1: "Schädlingsbekämpfung Kontrolle",
    Dezinskecija_Korekcija_V1: "Schädlingsbekämpfung Korrektur",
    Deratizacija_Kontrole_V1: "Nagetierkontrolle Kontrolle",
    Deratizacija_Korekcije_V1: "Nagetierkontrolle Korrektur",
    DezSr_V1: "Desinfektionsprodukte",
    Dobavljac_V1: "Lieferanten",
    Dostava_V1: "Lieferung",
    EduZap_V1: "Mitarbeiterausbildung",
    Mol_V1: "Malerarbeiten",
    Oprema_V1: "Ausrüstung",
    Otpad_V1: "Abfall",
    PrijemRobe_V1: "Wareneingang",
    San_V1: "Sanitäre Inspektion",
    Temperatura_V1: "Temperaturlisten",
    TemperaturaOgranicena_V1: "Temperaturlisten - begrenzt",
    TemperaturaOgranicenaKKT_V1: "Temperaturlisten - begrenzt - KKT",
    TemperaturaKKTProizvodiEvd_V1: "Temperaturlisten - Produkte - KKT",
    CheckListEvd_V1: "Checkliste",
  },
};

export interface GetQRResourcesInterface {
  title: string;
  subtitle: string;
  buttons: {
    popuni: string;
    pregled: string;
    primjedbe: string;
  };
  errors: {
    noinput: string;
    errorQuery: string;
    recordPointNotFound: {
      title: string;
      message: string;
      suggestion: string;
      icon: string;
    };
    privateAccess: {
      title: string;
      message: string;
      suggestion: string;
      icon: string;
      mobileMessage: string;
      mobileSuggestion: string;
    };
  };
  noItems: {
    title: string;
    message: string;
    suggestion: string;
  };
  noActiveRecords: {
    title: string;
    message: string;
    suggestion: string;
  };
  noRecordPoints: {
    message: string;
  };
  inputFields: {
    startDate: {
      label: string;
    };
    endDate: {
      label: string;
    };
  };
  poljaEvidencije: {
    CIPP_V1: string;
    CIPO_V1: string;
    Dezinfekcija_V1: string;
    Dezinsekcija_V1: string;
    Deratizacija_V1: string;
    Dezinsekcija_Kontrola_V1: string;
    Dezinskecija_Korekcija_V1: string;
    Deratizacija_Kontrole_V1: string;
    Deratizacija_Korekcije_V1: string;
    DezSr_V1: string;
    Dobavljac_V1: string;
    Dostava_V1: string;
    EduZap_V1: string;
    Mol_V1: string;
    Oprema_V1: string;
    Otpad_V1: string;
    PrijemRobe_V1: string;
    San_V1: string;
    Temperatura_V1: string;
    TemperaturaOgranicena_V1: string;
    TemperaturaOgranicenaKKT_V1: string;
    TemperaturaKKTProizvodiEvd_V1: string;
    CheckListEvd_V1: string;
  };
}

// http://localhost:3000/getqr?rtc=58&name=Dvoriste
